import React from 'react';
import styles from './Pagination.module.css';

const Pagination = ({
  currentPage,
  totalPages,
  onPageChange,
  showSizeChanger = false,
  pageSize = 20,
  onPageSizeChange,
  total = 0
}) => {
  const getPageNumbers = () => {
    const delta = 2;
    const range = [];
    const rangeWithDots = [];

    for (
      let i = Math.max(2, currentPage - delta);
      i <= Math.min(totalPages - 1, currentPage + delta);
      i++
    ) {
      range.push(i);
    }

    if (currentPage - delta > 2) {
      rangeWithDots.push(1, '...');
    } else {
      rangeWithDots.push(1);
    }

    rangeWithDots.push(...range);

    if (currentPage + delta < totalPages - 1) {
      rangeWithDots.push('...', totalPages);
    } else if (totalPages > 1) {
      rangeWithDots.push(totalPages);
    }

    return rangeWithDots;
  };

  const handlePageClick = (page) => {
    if (page !== '...' && page !== currentPage) {
      onPageChange(page);
    }
  };

  const handlePrevious = () => {
    if (currentPage > 1) {
      onPageChange(currentPage - 1);
    }
  };

  const handleNext = () => {
    if (currentPage < totalPages) {
      onPageChange(currentPage + 1);
    }
  };

  const handlePageSizeChange = (e) => {
    if (onPageSizeChange) {
      onPageSizeChange(parseInt(e.target.value));
    }
  };

  if (totalPages <= 1 && !showSizeChanger) {
    return null;
  }

  return (
    <div className={styles.pagination}>
      <div className={styles.paginationInfo}>
        共 {total} 条记录
      </div>

      <div className={styles.paginationControls}>
        <button
          className={styles.paginationBtn}
          onClick={handlePrevious}
          disabled={currentPage === 1}
        >
          上一页
        </button>

        <div className={styles.paginationPages}>
          {getPageNumbers().map((page, index) => (
            <button
              key={index}
              className={`${styles.paginationPage} ${
                page === currentPage ? styles.active : ''
              } ${page === '...' ? styles.dots : ''}`}
              onClick={() => handlePageClick(page)}
              disabled={page === '...'}
            >
              {page}
            </button>
          ))}
        </div>

        <button
          className={styles.paginationBtn}
          onClick={handleNext}
          disabled={currentPage === totalPages}
        >
          下一页
        </button>
      </div>

      {showSizeChanger && (
        <div className={styles.paginationSizeChanger}>
          <span>每页显示</span>
          <select value={pageSize} onChange={handlePageSizeChange}>
            <option value={10}>10</option>
            <option value={20}>20</option>
            <option value={50}>50</option>
            <option value={100}>100</option>
          </select>
          <span>条</span>
        </div>
      )}
    </div>
  );
};

export default Pagination;